import { useTranslation } from 'react-i18next';
import { User } from 'lucide-react';
import {
  ContactCard,
  type ContactDetails,
} from '~/components/cards/ContactCard';

export function BuyingInformationCard({
  buyerName,
  companyName,
  contact,
}: {
  buyerName: string;
  companyName: string;
  contact: ContactDetails | null;
}) {
  const { t } = useTranslation('order');

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <User size="20" className="text-prim" />
        <h2 className="text-neut-prim font-semibold">
          {t('order.customer_information')}
        </h2>
      </div>
      <div className="space-y-3">
        {contact ? (
          <ContactCard contact={contact} compact />
        ) : (
          <div>
            <p className="text-xs text-neut-sec mb-1">
              {t('order.buyer_name')}
            </p>
            <p className="text-sm text-neut-prim font-medium">{buyerName}</p>
          </div>
        )}
        <div>
          <p className="text-xs text-neut-sec mb-1">
            {t('order.buying_organization_name')}
          </p>
          <p className="text-sm text-neut-prim font-medium">{companyName}</p>
        </div>
      </div>
    </div>
  );
}
